import { css } from 'lit-element';
import { SharedStyles } from 'Styles/SharedStyles';

/**
 * Generate styles for lit-element
 * @param {Function} data context for style creation
 * @return {String} styles
 */
function getStyles(data) {

    return [
        SharedStyles,
        css`
            :host {
                --app-element-border-color: #e5e5e5;
                --app-element-focus-border-color: #e5daa5;
                --app-element-focus-background-color: #fffef9;
            }
            #input {
                border: 1px solid var(--app-element-border-color);
                height: 100%;
                padding-bottom: 15px;
                padding-left: 15px;
                padding-right: 15px;
                padding-top: 15px;
                width: 100%;
            }
            #input:focus {
                border-color: var(--app-element-focus-border-color);
                background-color: var(--app-element-focus-background-color);
            }
        `,
    ];

}

export { getStyles };
